module.exports = __webpack_public_path__ + "assets/download.5153dc2b.svg";